import { render } from "./ProjectGroupListPage.vue?vue&type=template&id=c762a06c&scoped=true&ts=true"
import script from "./ProjectGroupListPage.vue?vue&type=script&lang=ts"
export * from "./ProjectGroupListPage.vue?vue&type=script&lang=ts"

import "./ProjectGroupListPage.vue?vue&type=style&index=0&id=c762a06c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c762a06c"]])

export default __exports__